import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function VendorCustomerDetailSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default VendorCustomerDetailSkeleton;
